<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7585 14H5.23855C4.54055 14 3.96055 13.4613 3.90855 12.7646L3.31055 4.66663H12.6665L12.0885 12.7613C12.0385 13.4593 11.4579 14 10.7585 14V14Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99984 7.33337V11.3334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.6665 4.66671H13.3332"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3332 4.66667L10.6578 2.86533C10.4625 2.34467 9.96517 2 9.40917 2H6.5905C6.0345 2 5.53717 2.34467 5.34184 2.86533L4.6665 4.66667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2867 7.33337L10.0001 11.3334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.71344 7.33337L6.0001 11.3334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
